import { Divider } from "@material-ui/core"
import React from "react"
import { convertToLocalTime, getCaseStateIcon } from "../../commonFunctions/commonFunctions"
import SelectBox from "../common/CustomSelectBox"
import DateBox from "../common/CustomDateBox"
import { useSelector } from "react-redux"
import { selectHistoryCase } from "../../redux/contract/selectors"
import { TextBox } from "devextreme-react"
import { Comment } from "../common/Comment"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"


function HistoricCaseDetail(){
    const { t } = useTranslation();
    const caseInfo = useSelector(selectHistoryCase);

    const suppliers = [
      {
        id: 1,
        description: "Cadê Guincho"
      },
      {
        id: 2,
        description: "Amparo"
      },
      {
        id: 3,
        description: "SocorreAê"
      }
  ];

  const supplierServices = [
      {
        id: 1,
        description: "Carro Reserva"
      },
      {
        id: 2,
        description: "Chaveiro"
      },
      {
        id: 3,
        description: "Hotel"
      },
      {
        id: 4,
        description: "Reboque / Guincho"
      },
      {
        id: 5,
        description: "Socorro mecânico"
      },
      {
        id: 6,
        description: "Carga de Bateria / Auxiliar de Partida"
      },
      {
        id: 7,
        description: "Auxílio Combustível"
      },
      {
        id: 8,
        description: "Troca de pneu"
      },
      {
        id: 9,
        description: "Desatolamento / Remoção"
      },
      {
        id: 10,
        description: "Táxi / App Viagem / Mta"
      },
      {
        id: 11,
        description: "Troca de Bateria"
      }
  ];

    return( caseInfo ?
    <div style={{backgroundColor: "#fff", paddingTop: "0.5rem", paddingBottom: "1.5rem"}}>
        <div className="historic-case-title">
            <img width={24} src={getCaseStateIcon(caseInfo.stateId)}/> <span>{caseInfo.taxonomyLevel_1}</span>
        </div>
        <Divider orientation="horizontal"/>
        <div className="historic-case-basic-info">
            <div><span>Id Caso:</span>{caseInfo.caseId}</div>
            <div><span>Agente:</span>{caseInfo.user}</div>
            <div><span>Telefone:</span>{caseInfo.phoneNumber}</div>
            <div><span>Data Início:</span>{dayjs(convertToLocalTime(caseInfo.creationDate)).format("DD/MM/YYYY HH:mm")}</div>
            <div><span>Data Fim:</span>{caseInfo.closeDate ? dayjs(convertToLocalTime(caseInfo.closeDate)).format("DD/MM/YYYY HH:mm") : "-" }</div>
        </div>
        <div className="historic-case-detail-info">
            <SelectBox
                disabled
                label={t("EntryChannel")}
                value={caseInfo.entryChannel}
                dataSource={[caseInfo.entryChannel]}
            />
            <SelectBox
                disabled
                label={t("Level1")}
                value={caseInfo.taxonomyLevel_1}
                dataSource={[caseInfo.taxonomyLevel_1]}
            />
            <SelectBox
                disabled
                label={t("Level2")}
                value={caseInfo.taxonomyLevel_2}
                dataSource={[caseInfo.taxonomyLevel_2]}
            />
            <SelectBox
                disabled
                label={t("Level3")}
                value={caseInfo.taxonomyLevel_3}
                dataSource={[caseInfo.taxonomyLevel_3]}
            />
            <SelectBox
                disabled
                label={t("Level4")}
                value={caseInfo.taxonomyLevel_4}
                dataSource={[caseInfo.taxonomyLevel_4]}
            />
            <TextBox
                disabled
                label="Placa"
                value={caseInfo.mspPlate}
            />
            <TextBox
                disabled
                label="ID MSP"
                value={caseInfo.mspid}
            />
            <TextBox
                disabled
                label="ID Fornecedor"
                value={caseInfo.supplierProtocol}
            />
            <SelectBox
                disabled
                label={"Fornecedor"}
                displayExpr={"description"}
                valueExpr={"id"}
                value={caseInfo.supplierId}
                dataSource={suppliers}
            />
            <SelectBox
                disabled
                label={"Tipo Serviço"}
                displayExpr={"description"}
                valueExpr={"id"}
                value={caseInfo.supplierServiceId}
                dataSource={supplierServices}
            />
          <TextBox
                disabled
                label={t("AditionalInfo")}
                value={caseInfo.additionalInfo}
            />
            <SelectBox
                disabled
                label={t("State")}
                value={caseInfo.state}
                dataSource={[caseInfo.state]}
            />
            {/* <SelectBox
                disabled
                label={t("Substate")}
                value={caseInfo.subState}
                dataSource={[caseInfo.subState]}
            />
            <TextBox
                disabled
                label="Número de caso en fábrica"
                value={caseInfo.caseNumber}
            />
            <TextBox
                disabled
                label="Teléfono"
                value={caseInfo.phoneNumber}
            />
            <DateBox
                disabled
                label="Fecha de Agenda"
                value={caseInfo.scheduleDate}
            />
            <DateBox
                disabled
                label="Fecha de Escalado"
                value={caseInfo.transferDate}
            />
            <DateBox
                disabled
                label="Fecha de cierre en fábrica"
                value={caseInfo.factoryCloseDate}
            /> */}
            {/* <div style={{gridColumnStart: 1, gridColumnEnd: 5, display: "grid", gridTemplateColumns: "repeat(3, 1fr)", columnGap: "1rem"}}>
                <TextBox
                disabled
                label={t("AditionalInfo")}
                value={caseInfo.additionalInfo}
                />
                <TextBox
                    disabled
                    label="Motivo no preferente plus"
                    value={caseInfo.nonPPReason}
                />
                <TextBox
                    disabled
                    label="Taller"
                    value={caseInfo.workshop}
                />
            </div> */}
        </div>
        <div style={{margin: "3rem"}}>
            <div className="historic-case-comment-title">{t("CaseHistory")} - {caseInfo.caseId}</div>
            {caseInfo.comments.map(comment=> 
                    <Comment
                        state={comment.state} 
                        agent={comment.agent} 
                        date={comment.date} 
                        message={comment.message}
                    />
                    )
            }
        </div>
    </div>
    : null
    )
}

export {HistoricCaseDetail}